import Ajax from '@lib/ajax'

export default {
  async createEdit(payload) {
    return Ajax.post('/api/services/app/Post/CreateEditPost', payload)
  },
  async update(payload) {
    return Ajax.put('/api/services/app/Post/Update', payload.data)
  },
  async delete(id) {
    return Ajax.delete('/api/services/app/Post/Delete?Id=' + id)
  },
  async getPost(id) {
    return Ajax.get('/api/services/app/Post/GetPost?Id=' + id)
  },
  async get(id) {
    return Ajax.get('/api/services/app/Post/Get?Id=' + id)
  },
  async getAll(payload) {
    return Ajax.get('/api/services/app/Post/GetAll', { params: payload.data })
  },
  async find(query) {
    return Ajax.post('/api/services/app/Post/Find', { query: query })
  },
  async getArticlesGridResult(payload) {
    return Ajax.get('/api/services/app/Post/GetPostsGridResult', payload)
  },
}
